<template>
  <b-container>
    <b-row>
      <b-col
          v-for="(labelInfo, index) in labelsInfo"
          :key="labelInfo.fileId"
          class="pl-0 pr-1"
      >
        <b-link variant="link" @click="schedulePDF(labelInfo, index)">
          {{ labelInfo.__label__ }}
        </b-link>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: "BrandingLabelsRenderer",
  components: {},
  mounted() {
    this.afterMounted();
  },

  methods: {
    async schedulePDF(labelInfo, index) {
      try {
        await Rpc.plm.WclTemplates.schedulePDF(this.labels[index]);
      } catch (error) {
        console.error($tr("brandingLabelsRenderer.errorPDF", "An error occurred during PDF, error"));
      }
    },

    async afterMounted() {
      const removeTypename = (obj) => {
        if (!obj || typeof obj !== 'object') return obj;
        const {__typename__, ...rest} = obj;
        return rest;
      };
      const labels = await Rpc.plm.WclTemplates.loadLabelsShortForBrandingProductFromGridRenderer(
          this.model,
          this.model.brandingDetailsId
      ).lock();

      this.labels = labels;
      if (this.labels) {
        this.labelsInfo = labels.map(link => {
          return {
            ...link,
            __label__: this.generateName(link.fileName),
          };
        });
        for (let i = 0; i < this.labels.length; i++) {
          this.labels[i] = removeTypename(this.labels[i]);
        }
      } else {
        this.labelsInfo = [];
      }
    },

    generateName(str) {
      const dotIndex = str.indexOf('.');
      if (dotIndex === -1) {
        return str;
      }
      return str.substring(0, dotIndex);
    },
  },

  props: ["rowIndex", "prop", "model", "column"],

  watch: {
    model: async function (val) {
      await this.afterMounted();
    },
  },

  data: () => ({
    labels: [],
    labelsInfo: [],
  }),
};
</script>

<style scoped>
</style>